import React, { Component } from "react";
import { withStyles, Button, Typography } from "@material-ui/core";
import { GetData } from "../../../../api/service";
//import SmallBread from '../../../../SmallBread';
import ReactToPrint from "react-to-print";
import queryString from "query-string";
import Print from "@material-ui/icons/Print";
import QRCode from "react-qr-code";

import "./print.css";

const styles = (theme) => ({
  printContainer: {
    padding: "20px",
    textAlign: "center",
  },
  billContainer: {
    border: "solid thin lightgrey",
    width: "100%",
    minHeight: "100vh",
  },
  certiText: {
    fontSize: "1.2em",
    padding: "10px 10px 10px 10px",
    fontStyle: "italic",
    align: "center",
  },
});

class PrintCer extends Component {
  constructor(props) {
    super(props);

    let search = this.props.history.location.search;

    let searchData = queryString.parse(search);
    this.state = {
      id: searchData.certificate_request_id,
      cer_data: [],
      isLoadded: false,
    };
  }

  getDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    return (today = dd + "/" + mm + "/" + yyyy);
    //document.write(today);
  }

  componentDidMount() {
    let search = this.props.history.location.search;
    let searchData = queryString.parse(search);
    let id = searchData.certificate_request_id;
    //console.log(id);
    if (id !== undefined) {
      GetData(
        `/${id}/getcertificatesingleforprint`
      ).then((resp) => {
        console.log(resp);
        this.setState({
          cer_data: resp,
          isLoadded: true,
        });
      });
    } else {
      this.props.history.replace("/certificate");
    }
  }

  render() {
    let { classes } = this.props;
    return (
      <div className={classes.root}>
        

        <div className={classes.printContainer}>
          <ReactToPrint
            trigger={() => (
              <Button color="primary" variant="outlined">
                <Print /> Print{" "}
              </Button>
            )}
            content={() => this.componentRef}
            closeAfterPrint={true}
            pageStyle="margin: 10px"
          />

          <br />
          <br />

          {this.state.isLoadded ? (
            <PrintFormat
              {...this.props}
              ref={(el) => (this.componentRef = el)}
              data={this.state.cer_data}
              isLoaded={this.state.isLoaded}
            />
          ) : (
            "Loading...."
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(PrintCer);

class PrintFormat extends Component {
  render() {
    let { classes } = this.props;

    return (
      <div className="print-bill-container">
        <table width="100%">
          <tbody>
            <tr>
              <td width="33%" style={{ verticalAlign: "top", fontSize: 25 }}>
                <h6>From No. {this.props.data.from_no}</h6>
              </td>
              <td width="50%" align="center">
                <Typography style={{ fontSize: 20 }}>
                  OFFICE OF THE PRINCIPAL
                </Typography>
                <Typography style={{ fontSize: 25 }}>
                  PRAGJYOTISH COLLEGE
                </Typography>
              </td>
              <td width="33%">&nbsp;</td>
            </tr>
            <tr>
              <td colSpan="3" align="center">
                <img
                  src={require("./../../../../assets/logo-wide.png")}
                  style={{ width: "150px", height: "90px" }}
                />
                <QRCode value={this.props.data.qr_link} />
              </td>
            </tr>
            <tr>
              <td colSpan="3" align="center">
                <Typography>P.O. : GUWAHATI - 781012</Typography>
              </td>
            </tr>

            <tr>
              <td align="left">
                <br />
                <br />
                <Typography>Sl. No. {this.props.data.slr_no}</Typography>
              </td>
              <td>&nbsp;</td>
              <td align="right">
                <br />
                <br />

                <Typography>Date: {this.props.data.entry_date}</Typography>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <Typography className={classes.certiText}>
                  <br />
                  <br /> <br />
                  <br />
                  Certified that Shri / Miss / Mrs{" "}
                  <b>{this.props.data.name} &nbsp;&nbsp;&nbsp;</b> Roll -{" "}
                  <b>{this.props.data.roll}</b> &nbsp; No -
                  <b>{this.props.data.no}</b> &nbsp; has passed the{" "}
                  <b>{this.props.data.course}</b> &nbsp; Part -{" "}
                  <b>{this.props.data.part}</b>
                  &nbsp;Examination Of the University of Gauhati from this
                  College in the year - <b>{this.props.data.year}</b>&nbsp; with
                  Major in the Subject - <b>{this.props.data.major}</b> and was
                  placed in the <b>{this.props.data.division}</b>
                  &nbsp;Class / division.
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  I know nothing against him/her character.
                  <br />I wish him/her success in life.
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography>
                  Jalukbari
                  <br />
                  {/* {this.getDate()} */}
                </Typography>
              </td>
              <td>&nbsp;</td>
              <td>
                <Typography>
                  Principal
                  <br />
                  College
                  <br />
                  P.O. : GUWAHATI - 781012
                </Typography>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
